// import 家庭醫學科 from 'assets/departments/1_FamilyMedicine.png'
// import 內科 from 'assets/departments/2_InternalMedicine.png'
// import 外科 from 'assets/departments/3_surgery.png'
// import 兒科 from 'assets/departments/4_pediatrics.png'
// import 婦產科 from 'assets/departments/5_obstetrics_gynecology.png'
// import 骨科 from 'assets/departments/6_orthopedics.png'
// import 神經科 from 'assets/departments/7_neurology.png'
// import 神經外科 from 'assets/departments/8_neurosurgery.png'
// import 泌尿科 from 'assets/departments/9_urology.png'
// import 耳鼻喉科 from 'assets/departments/10_ent.png'
// import 眼科 from 'assets/departments/11_ophthalmology.png'
// import 皮膚科 from 'assets/departments/12_dermatology.png'
// import 精神科 from 'assets/departments/13_psychiatry.png'
// import 復健科 from 'assets/departments/14_rehabilitation.png'
// import 麻醉科 from 'assets/departments/15_anesthesiology.png'
// import 放射診斷科 from 'assets/departments/16_radiology_diagnostic.png'
// import 放射腫瘤科 from 'assets/departments/17_radiation_oncology.png'
// import 放射線科核醫 from 'assets/departments/18_nuclear_medicine_radiology.png'
// import 解剖病理科 from 'assets/departments/19_anatomical_pathology.png'
// import 臨床病理科 from 'assets/departments/20_clinical_pathology.png'
// import 核子醫學科 from 'assets/departments/21_nuclear_medicine.png'
// import 急診醫學科 from 'assets/departments/22_emergency_medicine.png'
// import 整形外科 from 'assets/departments/23_plastic_surgery.png'
// import 職業醫學科 from 'assets/departments/24_occupational_medicine.png'
// import 西醫一般科 from 'assets/departments/39_general_medicine.png'
// import 其他 from 'assets/departments/49_others.png'
// import 牙醫一般科 from 'assets/departments/51_dentistry.png'
// import 中醫一般科 from 'assets/departments/61_traditional_chinese_medicine.png'


// import 家庭醫學科 from 'assets/departments/1_FamilyMedicine.png'
// import 內科 from 'assets/departments/2_InternalMedicine.png'
import 外科 from 'assets/departments/3_surgery.png'
// import 兒科 from 'assets/departments/4_pediatrics.png'
import 婦產手術 from 'assets/departments/5_obstetrics_gynecology.png'
import 骨科手術 from 'assets/departments/6_orthopedics.png'
// import 神經科 from 'assets/departments/7_neurology.png'
// import 神經外科 from 'assets/departments/8_neurosurgery.png'
import 泌尿手術 from 'assets/departments/9_urology.png'
// import 耳鼻喉科 from 'assets/departments/10_ent.png'
import 眼科 from 'assets/departments/11_ophthalmology.png'
import 植髮手術 from 'assets/departments/12_dermatology.png'
// import 精神科 from 'assets/departments/13_psychiatry.png'
// import 復健科 from 'assets/departments/14_rehabilitation.png'
import 減重手術 from 'assets/departments/15_anesthesiology.png'
// import 放射診斷科 from 'assets/departments/16_radiology_diagnostic.png'
// import 放射腫瘤科 from 'assets/departments/17_radiation_oncology.png'
// import 放射線科核醫 from 'assets/departments/18_nuclear_medicine_radiology.png'
// import 腸胃鏡檢 from 'assets/departments/19_anatomical_pathology.png'
// import 臨床病理科 from 'assets/departments/20_clinical_pathology.png'
// import 核子醫學科 from 'assets/departments/21_nuclear_medicine.png'
// import 急診醫學科 from 'assets/departments/22_emergency_medicine.png'
import 醫美整形 from 'assets/departments/23_plastic_surgery.png'
// import 職業醫學科 from 'assets/departments/24_occupational_medicine.png'
// import 西醫一般科 from 'assets/departments/39_general_medicine.png'
import 其他 from 'assets/departments/49_others.png'
import 牙科治療 from 'assets/departments/51_dentistry.png'
// import 中醫一般科 from 'assets/departments/61_traditional_chinese_medicine.png'

import 痔瘡瘻管 from 'assets/departments/hemorrhoids.png'
import 乳房手術 from 'assets/departments/breast_surgery.png'
import 脊椎手術 from 'assets/departments/spinal_surgery.png'
import 腸胃鏡檢 from 'assets/departments/endoscopy.png'


export class SpecialtyDefine {
    id: number = 0;
    name: string = '';
    imageUrl: string = '';
    enMap: string = '';
    display: boolean = false;
}


// const specialtyDefines: SpecialtyDefine[] = [
//     { id: 1, name: '家庭醫學科', imageUrl: 家庭醫學科, enMap: 'family_medicine', display: false },
//     { id: 2, name: '內科', imageUrl: 內科, enMap: 'internal_medicine', display: false },
//     { id: 3, name: '外科', imageUrl: 外科, enMap: 'surgery', display: true },
//     { id: 4, name: '兒科', imageUrl: 兒科, enMap: 'pediatrics', display: false },
//     { id: 5, name: '婦產科', imageUrl: 婦產科, enMap: 'obstetrics_gynecology', display: true },
//     { id: 6, name: '骨科', imageUrl: 骨科, enMap: 'orthopedics', display: true },
//     { id: 7, name: '神經科', imageUrl: 神經科, enMap: 'neurology', display: false },
//     { id: 8, name: '神經外科', imageUrl: 神經外科, enMap: 'neurosurgery', display: false },
//     { id: 9, name: '泌尿科', imageUrl: 泌尿科, enMap: 'urology', display: true },
//     { id: 10, name: '耳鼻喉科', imageUrl: 耳鼻喉科, enMap: 'ent', display: false },
//     { id: 11, name: '眼科', imageUrl: 眼科, enMap: 'ophthalmology', display: true },
//     { id: 12, name: '皮膚科', imageUrl: 皮膚科, enMap: 'dermatology', display: true },
//     { id: 13, name: '精神科', imageUrl: 精神科, enMap: 'psychiatry', display: false },
//     { id: 14, name: '復健科', imageUrl: 復健科, enMap: 'rehabilitation', display: false },
//     { id: 15, name: '麻醉科', imageUrl: 麻醉科, enMap: 'anesthesiology', display: false },
//     { id: 16, name: '放射診斷科', imageUrl: 放射診斷科, enMap: 'radiology_diagnostic', display: false },
//     { id: 17, name: '放射腫瘤科', imageUrl: 放射腫瘤科, enMap: 'radiation_oncology', display: false },
//     { id: 18, name: '放射線科(核醫)', imageUrl: 放射線科核醫, enMap: 'nuclear_medicine_radiology', display: false },
//     { id: 19, name: '解剖病理科', imageUrl: 解剖病理科, enMap: 'anatomical_pathology', display: false },
//     { id: 20, name: '臨床病理科', imageUrl: 臨床病理科, enMap: 'clinical_pathology', display: false },
//     { id: 21, name: '核子醫學科', imageUrl: 核子醫學科, enMap: 'nuclear_medicine', display: false },
//     { id: 22, name: '急診醫學科', imageUrl: 急診醫學科, enMap: 'emergency_medicine', display: false },
//     { id: 23, name: '整形外科', imageUrl: 整形外科, enMap: 'plastic_surgery', display: true },
//     { id: 24, name: '職業醫學科', imageUrl: 職業醫學科, enMap: 'occupational_medicine', display: false },
//     { id: 39, name: '西醫一般科', imageUrl: 西醫一般科, enMap: 'general_medicine', display: false },
//     { id: 49, name: '其他', imageUrl: 其他, enMap: 'others', display: false },
//     { id: 51, name: '牙醫一般科', imageUrl: 牙醫一般科, enMap: 'dentistry', display: true },
//     { id: 61, name: '中醫一般科', imageUrl: 中醫一般科, enMap: 'traditional_chinese_medicine', display: false }
// ]

// const specialtyDefinesDisplaied: SpecialtyDefine[] = [
//     { id: 3, name: '外科', imageUrl: 外科, enMap: 'surgery', display: true },
//     { id: 5, name: '婦產科', imageUrl: 婦產科, enMap: 'obstetrics_gynecology', display: true },
//     { id: 6, name: '骨科', imageUrl: 骨科, enMap: 'orthopedics', display: true },
//     { id: 9, name: '泌尿科', imageUrl: 泌尿科, enMap: 'urology', display: true },
//     { id: 11, name: '眼科', imageUrl: 眼科, enMap: 'ophthalmology', display: true },
//     { id: 12, name: '皮膚科', imageUrl: 皮膚科, enMap: 'dermatology', display: true },
//     { id: 23, name: '整形外科', imageUrl: 整形外科, enMap: 'plastic_surgery', display: true },
//     { id: 51, name: '牙醫一般科', imageUrl: 牙醫一般科, enMap: 'dentistry', display: true },
// ]


const specialtyDefinesDisplaied: SpecialtyDefine[] = [
    {
        id: 9,
        name: '婦產手術',
        imageUrl: 婦產手術,
        enMap: 'obsgyn',
        display: true
    },
    {
        id: 21,
        name: '骨科手術',
        imageUrl: 骨科手術,
        enMap: 'orthopedic',
        display: true
    },
    {
        id: 34,
        name: '泌尿手術',
        imageUrl: 泌尿手術,
        enMap: 'urology',
        display: true
    },
    {
        id: 20,
        name: '脊椎手術',
        imageUrl: 脊椎手術,
        enMap: 'spinaloperation',
        display: true
    },

    {
        id: 37,
        name: '眼科手術',
        imageUrl: 眼科,
        enMap: 'eyesurgery',
        display: true
    },

    {
        id: 24,
        name: '植髮手術',
        imageUrl: 植髮手術,
        enMap: 'hairimplant',
        display: true
    },

    {
        id: 14,
        name: '醫美整形',
        imageUrl: 醫美整形,
        enMap: 'plastic',
        display: true
    },
    {
        id: 15,
        name: '腸胃鏡檢',
        imageUrl: 腸胃鏡檢,
        enMap: 'endoscopy',
        display: true
    },
    {
        id: 31,
        name: '靜脈曲張',
        imageUrl: 植髮手術,
        enMap: 'varicose',
        display: true
    },
    {
        id: 35,
        name: '痔瘡瘻管',
        imageUrl: 痔瘡瘻管,
        enMap: 'hemmorhoid',
        display: true
    },
    {
        id: 36,
        name: '牙科治療',
        imageUrl: 牙科治療,
        enMap: 'dentist',
        display: true
    },
    {
        id: 38,
        name: '乳房手術',
        imageUrl: 乳房手術,
        enMap: 'breastsurgery',
        display: true
    },
    {
        id: 42,
        name: '減重手術',
        imageUrl: 減重手術,
        enMap: 'bariatrics',
        display: true
    },
]
const specialtyDefines: SpecialtyDefine[] = [
    {
        id: 9,
        name: '婦產手術',
        imageUrl: 婦產手術,
        enMap: 'obsgyn',
        display: true
    },
    {
        id: 14,
        name: '醫美整形',
        imageUrl: 醫美整形,
        enMap: 'plastic',
        display: true
    },
    {
        id: 21,
        name: '骨科手術',
        imageUrl: 骨科手術,
        enMap: 'orthopedic',
        display: true
    },
    {
        id: 20,
        name: '脊椎手術',
        imageUrl: 脊椎手術,
        enMap: 'spinaloperation',
        display: true
    },
    {
        id: 15,
        name: '腸胃鏡檢',
        imageUrl: 腸胃鏡檢,
        enMap: 'endoscopy',
        display: true
    },
    {
        id: 34,
        name: '泌尿手術',
        imageUrl: 泌尿手術,
        enMap: 'urology',
        display: true
    },
    {
        id: 36,
        name: '牙科治療',
        imageUrl: 牙科治療,
        enMap: 'dentist',
        display: true
    },
    {
        id: 24,
        name: '植髮手術',
        imageUrl: 植髮手術,
        enMap: 'hairimplant',
        display: true
    },
    {
        id: 35,
        name: '痔瘡瘻管',
        imageUrl: 痔瘡瘻管,
        enMap: 'hemmorhoid',
        display: true
    },
    {
        id: 41,
        name: '甲腺手術',
        imageUrl: 外科,
        enMap: 'thyroid',
        display: true
    },
    {
        id: 37,
        name: '眼科手術',
        imageUrl: 眼科,
        enMap: 'eyesurgery',
        display: true
    },
    {
        id: 31,
        name: '靜脈曲張',
        imageUrl: 植髮手術,
        enMap: 'varicose',
        display: true
    },
    {
        id: 42,
        name: '減重手術',
        imageUrl: 減重手術,
        enMap: 'bariatrics',
        display: true
    },
    {
        id: 38,
        name: '乳房手術',
        imageUrl: 植髮手術,
        enMap: 'breastsurgery',
        display: true
    },
    {
        id: 44,
        name: '手汗手術',
        imageUrl: 植髮手術,
        enMap: 'hyperhidrosis',
        display: true
    },
    {
        id: 22,
        name: '其他手術',
        imageUrl: 其他,
        enMap: 'others',
        display: true
    },
]

export { specialtyDefines, specialtyDefinesDisplaied }